import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import vi from '../locales/vi.json';
import en from '../locales/en.json';
import ru from '../locales/ru.json';

export const LOCALE_STORAGE_KEY = 'airex_cp_lk_locale';

export type AppLocale = 'vi' | 'en' | 'ru';

export const APP_LOCALES: AppLocale[] = ['vi', 'en', 'ru'];

function readStoredLocale(): AppLocale {
  try {
    const s = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (s === 'vi' || s === 'en' || s === 'ru') return s;
  } catch {
    /* ignore */
  }
  return 'vi';
}

void i18n.use(initReactI18next).init({
  resources: {
    vi: { translation: vi },
    en: { translation: en },
    ru: { translation: ru },
  },
  lng: readStoredLocale(),
  fallbackLng: 'vi',
  supportedLngs: ['vi', 'en', 'ru'],
  interpolation: { escapeValue: false },
  returnNull: false,
});

if (typeof document !== 'undefined') {
  document.documentElement.lang = readStoredLocale();
}

export function setAppLocale(lng: AppLocale): void {
  localStorage.setItem(LOCALE_STORAGE_KEY, lng);
  void i18n.changeLanguage(lng);
  const htmlLang = lng === 'vi' ? 'vi' : lng === 'ru' ? 'ru' : 'en';
  document.documentElement.lang = htmlLang;
}

/** BCP 47 для Intl / toLocaleString */
export function intlLocaleFor(lng: string): string {
  if (lng === 'vi') return 'vi-VN';
  if (lng === 'ru') return 'ru-RU';
  return 'en-US';
}

export default i18n;
